// Użytkownicy z dostępem do modułu "Raport czasów odpraw" (link w menu UserDashboard).
// Ta sama lista jest w backendzie: Transport-Back/raportCzasowOdprawRoutes.js
export const RAPORT_CZASOW_USERS = [
  "Maciej",
  "plomza",
  "adobrowolska",
  "dczernikowska",
  "pnowak",
];

export const isRaportCzasowUser = (username) =>
  RAPORT_CZASOW_USERS.includes(username);
